import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const CommunityUsageLessonsLink = (context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.collective_usage_lessons',
    link: '/lessons/list/search',
    queryParams: {usage: context.usages.communityId}, // Généré par le service
    icon: 'navigation-link__community-usage-lessons',
});